import { useQuery, useMutation } from "@tanstack/react-query";
import { instanceWithToken } from "../../axios.config";

export const useReserve = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("reservations", body);
      return data;
    },
  });
};
